<template>
    <g id="nose" transform="translate(28.000000, 40.000000)" fill="#00000" fill-opacity="0.16">
        <path 
        d="M16,8 C16,12.418278 21.372583,16 28,16 L28,16 C34.627417,16 40,12.418278 40,8"
        ></path>
    </g>
</template>


<script>

export default {
  name: 'Nose',
  props: {

  },
  data() {
    return {

    }
  },
}
</script>


<style scoped>

</style>